import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useUpdateSettings } from "@/hooks/queries";
import { toast } from "sonner";

export function VoicePicker({ voices, value, disabled }) {
  const update = useUpdateSettings();
  if (!voices?.length) return null;
  return (
    <Select value={value} disabled={disabled} onValueChange={(voice) => update.mutate({ voice }, { onError: (e) => toast.error(e.message) })}>
      <SelectTrigger className="h-9 w-[150px] rounded-full border-white/12 bg-transparent text-[13px] text-zinc-200" aria-label="JARVIS voice" data-testid="voice-picker-trigger">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="border-white/10 bg-ink-850 text-zinc-200">
        {voices.map((v) => (
          <SelectItem key={v.key} value={v.key} data-testid={`voice-picker-option-${v.key}`}>
            {v.label} voice
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
